<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="page-header-index-wide">
        <a-row :gutter="6">
          <a-col :sm="6" :md="6" :xl="3" :style="{ marginBottom: '24px' }">
            <a-button style="width: 100%;height: 100%" :type="buttonType1" @click="handleQueryByType(1)">
              <font size="3px">{{ '全部' }}</font><br/>
              <font size="6px">{{ userCount.oneCount }}</font>
            </a-button>
          </a-col>
          <a-col :sm="6" :md="6" :xl="3" :style="{ marginBottom: '24px' }">
            <a-button style="width: 100%;height: 100%" :type="buttonType2" @click="handleQueryByType(2)">
              <font size="3px">{{ '跟进中' }}</font><br/>
              <font size="6px">{{ userCount.twoCount }}</font>
            </a-button>
          </a-col>
          <a-col :sm="6" :md="6" :xl="3" :style="{ marginBottom: '24px' }">
            <a-button style="width: 100%;height: 100%" :type="buttonType3" @click="handleQueryByType(3)">
              <font size="3px">{{ '报备客户' }}</font><br/>
              <font size="6px">{{ userCount.threeCount }}</font>
            </a-button>
          </a-col>
          <a-col :sm="6" :md="6" :xl="3" :style="{ marginBottom: '24px' }">
            <a-button style="width: 100%;height: 100%" :type="buttonType4" @click="handleQueryByType(4)">
              <font size="3px">{{ '面试客户' }}</font><br/>
              <font size="6px">{{ userCount.fourCount }}</font>
            </a-button>
          </a-col>
          <a-col :sm="6" :md="6" :xl="3" :style="{ marginBottom: '24px' }">
            <a-button style="width: 100%;height: 100%" :type="buttonType5" @click="handleQueryByType(5)">
              <font size="3px">{{ '入职失败' }}</font><br/>
              <font size="6px">{{ userCount.fiveCount }}</font>
            </a-button>
          </a-col>
          <a-col :sm="6" :md="6" :xl="3" :style="{ marginBottom: '24px' }">
            <a-button style="width: 100%;height: 100%" :type="buttonType6" @click="handleQueryByType(6)">
              <font size="3px">{{ '在职员工' }}</font><br/>
              <font size="6px">{{ userCount.sixCount }}</font>
            </a-button>
          </a-col>
          <a-col :sm="6" :md="6" :xl="3" :style="{ marginBottom: '24px' }">
            <a-button style="width: 100%;height: 100%" :type="buttonType7" @click="handleQueryByType(7)">
              <font size="3px">{{ '离职员工' }}</font><br/>
              <font size="6px">{{ userCount.sevenCount }}</font>
            </a-button>
          </a-col>
          <a-col :sm="6" :md="6" :xl="3" :style="{ marginBottom: '24px' }">
            <a-button style="width: 100%;height: 100%" :type="buttonType8" @click="handleQueryByType(8)">
              <font size="3px">{{ '公海' }}</font><br/>
              <font size="6px">{{ userCount.eightCount }}</font>
            </a-button>
          </a-col>

        </a-row>
      </div>
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="身份证" prop="idCard">
                <a-input v-model="queryParam.idCard" placeholder="请输入身份证" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入手机号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="学历" prop="education">
                <a-select v-model="queryParam.education" placeholder="请选择" allow-clear>
                  <a-select-option value="1">高中</a-select-option>
                  <a-select-option value="2">大专</a-select-option>
                  <a-select-option value="3">本科</a-select-option>
                  <a-select-option value="4">研究生</a-select-option>
                  <a-select-option value="5">博士生</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="最小年龄" prop="ageMin">
                  <a-input type="number" v-model="queryParam.ageMin" placeholder="最小年龄" :min="0" :max="120"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最大年龄" prop="ageMin">
                  <a-input type="number" v-model="queryParam.ageMax" placeholder="最大年龄" :min="0" :max="120"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最新报名时间" prop="newApplyDate">
                  <a-range-picker
                    style="width: 100%"
                    v-model="newApplyDate"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最新跟进时间" prop="newFollowDate">
                  <a-range-picker
                    style="width: 100%"
                    v-model="newFollowDate"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="来源渠道" prop="sourceChannel">
                  <a-select placeholder="请选择" v-model="queryParam.sourceChannel" allow-clear>
                    <a-select-option
                      v-for="(sourceChannel,index) in sourceChannelList"
                      :key="index"
                      :value="sourceChannel.id">
                      {{ sourceChannel.content }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="性别" prop="sex">
                  <a-select placeholder="请选择" v-model="queryParam.sex" allow-clear>
                    <a-select-option value="0">保密</a-select-option>
                    <a-select-option value="1">男</a-select-option>
                    <a-select-option value="2">女</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="来源类型" prop="sourceType">
                  <a-select v-model="queryParam.sourceType" placeholder="请选择" allow-clear>
                    <a-select-option value="1">平台分享</a-select-option>
                    <a-select-option value="2">招聘专员分享</a-select-option>
                    <a-select-option value="3">推荐官分享</a-select-option>
                    <a-select-option value="4">推荐官专员分享</a-select-option>
                    <a-select-option value="5">驻场客服分享</a-select-option>
                    <a-select-option value="6">其他</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="招聘专员" prop="topNickname">
                  <a-input v-model="queryParam.topNickname" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="推荐官" prop="referralsNickname">
                  <a-input v-model="queryParam.referralsNickname" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="推荐专员" prop="topReferralsNickname">
                  <a-input v-model="queryParam.topReferralsNickname" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="邀请所属" prop="inviteUserName">
                  <a-input v-model="queryParam.inviteUserName" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最近所在地" prop="location">
                  <a-input v-model="queryParam.location" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="微信添加状态" prop="addWx">
                  <a-select v-model="queryParam.addWx" placeholder="请输入" allow-clear>
                    <a-select-option :value="0">未加</a-select-option>
                    <a-select-option :value="1">已加</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最新报名公司" prop="newApplyCompany">
                  <a-input v-model="queryParam.newApplyPost" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最新报名职位" prop="newApplyPost">
                  <a-input v-model="queryParam.newApplyPost" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最新动态更新时间" prop="newBrowseDate">
                  <a-range-picker
                    style="width: 100%"
                    v-model="newBrowseDate"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最新跟进结果" prop="newResultType">
                  <a-select v-model="queryParam.newResultType" placeholder="请选择" allow-clear>
                    <a-select-option :value="1">暂无意向</a-select-option>
                    <a-select-option :value="2">未联系上</a-select-option>
                    <a-select-option :value="3">有意向</a-select-option>
                    <a-select-option :value="4">无效信息</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="标签" prop="tagId">
                  <a-select
                    v-model="tagId"
                    placeholder="请选择"
                    optionFilterProp="children"
                    showSearch
                    mode="multiple"
                    allow-clear>
                    <a-select-option v-for="(tag,index) in tagList" :key="index" :value="tag.id">{{
                      tag.name
                    }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="创建时间" prop="rangeDate">
                  <a-range-picker
                    style="width: 100%"
                    v-model="rangeDate"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最新跟进人" prop="newFollowName">
                  <a-input v-model="queryParam.newFollowName" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo"/>重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.addUserForm.handleAdd()" v-hasPermi="['biz:user:add']">
          <a-icon type="plus"/>
          新增
        </a-button>
        <a-button type="primary" @click="$refs.uploadForm.handleAdd()" v-hasPermi="['biz:user:import']">
          <a-icon type="upload"/>
          批量导入
        </a-button>
        <a-button
          type="primary"
          @click="$refs.uploadUpdateStatusForm.handleAdd()"
          v-hasPermi="['biz:user:importSetstate']">
          <a-icon type="upload"/>
          批量修改用户状态导入
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['biz:user:remove']">
          <a-icon type="delete"/>
          批量删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['biz:user:export']">
          <a-icon type="download"/>
          导出
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="handleStatus" v-hasPermi="['biz:user:setstate']">
          <a-icon type="edit"/>
          设置状态
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"/>
      </div>
      <set-status-form
        ref="setStatusForm"
      />
      <add-user-form
        ref="addUserForm"
      />
      <upload-form
        ref="uploadForm"
      />
      <upload-update-status-form
        ref="uploadUpdateStatusForm"
      />
      <!-- 查看/修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <follow-create-form
        ref="followCreateForm"
      />
      <report-create-form
        ref="reportCreateForm"
      />
      <other-form
        ref="otherForm"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 2700}"
      >
        <span slot="status" slot-scope="text, record">
          <div>
            <a-switch @click="updateStatus(record)" v-model="record.status == 1">
              <a-icon type="check" slot="checkedChildren"/>
              <a-icon type="close" slot="unCheckedChildren"/>
            </a-switch>
          </div>
        </span>
        <span slot="isWork" slot-scope="text, record">
          <div>
            <a-switch @click="updateIsWork(record)" v-model="record.isWork == 1">
              <a-icon type="check" slot="checkedChildren"/>
              <a-icon type="close" slot="unCheckedChildren"/>
            </a-switch>
          </div>
        </span>
        <span slot="tagName" slot-scope="text, record">
          <a-tag v-if="record.tagName" v-for="(tag) in record.tagName.split(',')" color="blue">
            {{ tag }}
          </a-tag>
          <div v-else>
            暂无
          </div>
        </span>
        <span slot="userStatus" slot-scope="text, record">
          <a-tag v-if="record.userStatus" color="blue">
            {{
              record.userStatus === 1 ? '跟进中' :
              record.userStatus === 2 ? '报备中' :
              record.userStatus === 3 ? '面试体检中' :
              record.userStatus === 4 ? '面试成功' :
              record.userStatus === 5 ? '复检' :
              record.userStatus === 6 ? '入职失败' :
              record.userStatus === 7 ? '在职员工' :
              record.userStatus === 8 ? '离职员工' : '公海'
            }}
          </a-tag>
          <div v-else>
            暂无
          </div>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit"/>查看/编辑
          </a>
          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <a-icon type="double-right"/>
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="$refs.otherForm.handleUpdate(record, undefined)">
                  <a-icon type="edit"/>补录信息
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 1 || record.userStatus === 6">
                <a @click="handleHighSeas(record.id)">
                  <a-icon type="check-circle"/>投入公海
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 1 || record.userStatus === 6 || record.userStatus === 8">
                <a @click="$refs.followCreateForm.handleAdd(record.id)">
                  <a-icon type="check-circle"/>跟进
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 1 || record.userStatus === 6">
                <a @click="$refs.reportCreateForm.handleAdd(record.id)">
                  <a-icon type="check-circle"/>报备
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 2">
                <a @click="immediateInterview(record.id)">
                  <a-icon type="check-circle"/>立即面试
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 3">
                <a @click="handleInterview(record.id,1)">
                  <a-icon type="check-circle"/>面试成功
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 3">
                <a @click="handleInterview(record.id,2)">
                  <a-icon type="check-circle"/>面试失败
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 3">
                <a @click="handleInterview(record.id,3)">
                  <a-icon type="check-circle"/>面试未到
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 4">
                <a @click="handleInterview(record.id,4)">
                  <a-icon type="check-circle"/>在职员工
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 4">
                <a @click="handleInterview(record.id,5)">
                  <a-icon type="check-circle"/>面试成功体检失败
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 4">
                <a @click="handleInterview(record.id,6)">
                  <a-icon type="check-circle"/>面试成功体检失败需复检
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 4">
                <a @click="handleInterview(record.id,7)">
                  <a-icon type="check-circle"/>面试成功未体检
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 4">
                <a @click="handleInterview(record.id,8)">
                  <a-icon type="check-circle"/>体检成功未入职
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 5">
                <a @click="handleInterview(record.id,9)">
                  <a-icon type="check-circle"/>复检成功并入职
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 5">
                <a @click="handleInterview(record.id,10)">
                  <a-icon type="check-circle"/>复检成功未入职
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 5">
                <a @click="handleInterview(record.id,11)">
                  <a-icon type="check-circle"/>复检失败
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 7">
                <a @click="handleInterview(record.id,12)">
                  <a-icon type="check-circle"/>离职
                </a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus === 9">
                <a @click="handleHighSeasReceive(record.id)">
                  <a-icon type="check-circle"/>领取
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['biz:user:remove']" v-lacksPermi="['biz:user:remove']">
                <a @click="handleDelete(record)" v-hasPermi="['biz:user:remove']" v-lacksPermi="['biz:user:remove']">
                  <a-icon type="delete"/>删除
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <a-modal
        :title="operateTitle"
        :width="500"
        :visible="operateOpen"
        @cancel="operateClose"
        @ok="operateOk"
      >
        <a-form-model>
          <a-form-model-item v-if="interviewType" label="岗位">
            <a-select v-model="reportPost" @change="handleReportPostList">
              <a-select-option v-for="(reportPost,index) in reportPostList" :key="index" :value="reportPost">
                {{ reportPost.postName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-if="interviewType === 4 || interviewType === 9" label="入职时间">
            <a-date-picker
              style="width: 100%"
              v-model="entryTime"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              show-time
              allow-clear/>
          </a-form-model-item>
          <a-form-model-item v-if="interviewType === 4 || interviewType === 9" label="入职的岗位">
            <a-select v-model="entryWork" style="width: 100%">
              <a-select-option v-for="(work,index) in workTypeList" :key="index" :value="work.id">
                {{ work.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-if="interviewType === 12" label="离职时间">
            <a-date-picker
              style="width: 100%"
              v-model="dimissionTime"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              show-time
              allow-clear/>
          </a-form-model-item>
        </a-form-model>
        <a-textarea v-model="remark" :row="3" placeholder="备注"/>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageUser,
  queryUserCountByType,
  querySourceChannelList,
  delUser,
  updateUser,
  addHighSeas,
  workbenchDispose,
  highSeasReceive,
  listReportPost,
  immediateInterview,
  getUser
} from '@/api/biz/user'
import { listWork } from '@/api/user/work'
import CreateForm from './modules/CreateForm'
import OtherForm from './modules/OtherForm'
import FollowCreateForm from './modules/FollowCreateForm'
import ReportCreateForm from './modules/ReportCreateForm'
import { tableMixin } from '@/store/table-mixin'
import AddUserForm from './modules/AddUserForm'
import UploadForm from './modules/UploadForm'
import SetStatusForm from '@/views/biz/user/modules/SetStatusForm'
import UploadUpdateStatusForm from './modules/UploadUpdateStatusForm'
import { listTag } from '@/api/user/tag'

export default {
  name: 'User',
  components: {
    OtherForm,
    UploadUpdateStatusForm,
    SetStatusForm,
    UploadForm,
    AddUserForm,
    CreateForm,
    FollowCreateForm,
    ReportCreateForm
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data() {
    return {
      list: [],
      operateTitle: null,
      operateOpen: false,
      operateType: null,
      userId: null,
      interviewType: null,
      selectedRowKeys: [],
      selectedRows: [],
      reportPost: null,
      postId: null,
      companyId: null,
      reportPostList: [],
      workTypeList: [],
      entryTime: null,
      dimissionTime: null,
      entryWork: null,
      remark: null,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      buttonType1: 'primary',
      buttonType2: '',
      buttonType3: '',
      buttonType4: '',
      buttonType5: '',
      buttonType6: '',
      buttonType7: '',
      buttonType8: '',
      ids: [],
      userCount: {},
      sourceChannelList: [],
      loading: false,
      total: 0,
      rangeDate: null,
      newApplyDate: null,
      newFollowDate: null,
      newBrowseDate: null,
      tagList: [],
      tagId: [],
      // 查询参数
      queryParam: {
        newFollowName: null,
        tagId: null,
        newResultType: null,
        newApplyPost: null,
        addWx: null,
        sheng: null,
        shi: null,
        xian: null,
        ageMin: null,
        ageMax: null,
        type: 1,
        nickname: null,
        mobile: null,
        idCard: null,
        education: null,
        sourceChannel: null,
        sex: null,
        sourceType: null,
        topNickname: null,
        referralsNickname: null,
        topReferralsNickname: null,
        inviteUserName: null,
        startTime: null,
        endTime: null,
        startApplyTime: null,
        endApplyTime: null,
        startFollowTime: null,
        endFollowTime: null,
        startBrowseTime: null,
        endBrowseTime: null,
        location: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '姓名',
          dataIndex: 'realName',
          ellipsis: true,
          width: 120,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          width: 120,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '用户ID',
          dataIndex: 'id',
          ellipsis: true,
          width: 180,
          align: 'center'
        },
        {
          title: '身份证号',
          dataIndex: 'idCard',
          ellipsis: true,
          width: 180,
          align: 'center'
        },
        {
          title: '性别',
          dataIndex: 'sex',
          ellipsis: true,
          width: 80,
          align: 'center',
          customRender: function (sex) {
            if (sex === 0) {
              return '保密'
            } else if (sex === 1) {
              return '男'
            } else if (sex === 2) {
              return '女'
            }
          }
        },
        {
          title: '来源渠道',
          dataIndex: 'sourceChannelName',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '来源类型',
          dataIndex: 'sourceType',
          ellipsis: true,
          width: 120,
          align: 'center',
          customRender: function (sourceType) {
            if (sourceType === 1) {
              return '平台分享'
            } else if (sourceType === 2) {
              return '招聘专员分享'
            } else if (sourceType === 3) {
              return '推荐官分享'
            } else if (sourceType === 4) {
              return '推荐官专员分享'
            } else if (sourceType === 5) {
              return '驻场客服分享'
            } else if (sourceType === 6) {
              return '其他'
            }
          }
        },
        {
          title: '邀请所属',
          dataIndex: 'inviteUserNickname',
          ellipsis: true,
          width: 120,
          align: 'center',
          customRender: function (inviteUserNickname) {
            if (inviteUserNickname) {
              return inviteUserNickname
            } else {
              return '-'
            }
          }
        },
        {
          title: '推荐官',
          dataIndex: 'referralsName',
          ellipsis: true,
          width: 120,
          align: 'center',
          customRender: function (referralsName) {
            if (referralsName) {
              return referralsName
            } else {
              return '-'
            }
          }
        },
        {
          title: '所属招聘专员',
          dataIndex: 'topName',
          ellipsis: true,
          width: 120,
          align: 'center',
          customRender: function (topName) {
            if (topName) {
              return topName
            } else {
              return '-'
            }
          }
        },
        {
          title: '所属推荐官专员',
          dataIndex: 'topReferralsName',
          ellipsis: true,
          width: 120,
          align: 'center',
          customRender: function (topReferralsName) {
            if (topReferralsName) {
              return topReferralsName
            } else {
              return '-'
            }
          }
        },
        {
          title: '最近访问地',
          dataIndex: 'recentlyVisitedPlace',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '报备订单数',
          dataIndex: 'reportCount',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '跟进日志数',
          dataIndex: 'followCount',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '标签',
          dataIndex: 'tagName',
          scopedSlots: { customRender: 'tagName' },
          width: 200,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 200,
          align: 'center'
        },
        {
          title: '操作状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 120,
          fixed: 'right',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'userStatus',
          scopedSlots: { customRender: 'userStatus' },
          width: 120,
          fixed: 'right',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.handleQuery()
    this.querySourceChannel()
    this.queryTagList()
  },
  computed: {},
  watch: {},
  methods: {
    queryTagList() {
      const param = { type: 3 }
      listTag(param).then(response => {
        this.tagList = response.data
      })
    },
    onChangeCascader(e) {
      console.log(e)
      if (e.length === 3) {
        this.queryParam.xian = e[1]
        this.queryParam.shi = e[1]
        this.queryParam.sheng = e[0]
      } else if (e.length === 2) {
        this.queryParam.shi = e[1]
        this.queryParam.sheng = e[0]
      } else if (e.length === 1) {
        this.queryParam.sheng = e[0]
      } else {
        this.queryParam.xian = null
        this.queryParam.shi = null
        this.queryParam.sheng = null
      }
    },
    handleReportPostList(reportPost) {
      debugger
      this.postId = reportPost.postId
      this.companyId = reportPost.companyId
    },
    updateIsWork(record) {
      let param = {}
      getUser({ 'id': record.id }).then(response => {
        param = { ...response.data }
        // 更改状态
        param.isWork = (record.isWork === 0) ? 1 : 0
        updateUser(record).then(response => {
          this.$message.success(
            '修改成功',
            3
          )
          this.$emit('ok')
        }).finally(() => {
          this.getList()
        })
      })
    },
    updateStatus(record) {
      let param = {}
      getUser({ 'id': record.id }).then(response => {
        param = { ...response.data }
        param.status = (record.status === 0) ? 1 : 0
        updateUser(param).then(response => {
          this.$message.success(
            '修改成功',
            3
          )
          this.$emit('ok')
        }).finally(() => {
          this.getList()
        })
      })
    },
    querySourceChannel() {
      querySourceChannelList().then(response => {
        this.sourceChannelList = response.data
      })
    },
    queryUserCount() {
      queryUserCountByType(this.queryParam).then(response => {
        this.userCount = response.data
      })
    },
    handleQueryByType(type) {
      this.buttonReset()
      if (type === 1) {
        this.buttonType1 = 'primary'
      } else if (type === 2) {
        this.buttonType2 = 'primary'
      } else if (type === 3) {
        this.buttonType3 = 'primary'
      } else if (type === 4) {
        this.buttonType4 = 'primary'
      } else if (type === 5) {
        this.buttonType5 = 'primary'
      } else if (type === 6) {
        this.buttonType6 = 'primary'
      } else if (type === 7) {
        this.buttonType7 = 'primary'
      } else if (type === 8) {
        this.buttonType8 = 'primary'
      }
      this.queryParam.type = type
      this.queryParam.pageNum = 1
      this.getList()
      this.queryUserCount()
    },
    /** 查询用户信息列表 */
    getList() {
      this.loading = true
      pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      if (this.rangeDate) {
        this.queryParam.startTime = this.rangeDate[0]
        this.queryParam.endTime = this.rangeDate[1]
      }
      if (this.newApplyDate) {
        this.queryParam.startApplyTime = this.newApplyDate[0]
        this.queryParam.endApplyTime = this.newApplyDate[1]
      }
      if (this.newFollowDate) {
        this.queryParam.startFollowTime = this.newFollowDate[0]
        this.queryParam.endFollowTime = this.newFollowDate[1]
      }
      if (this.newBrowseDate) {
        this.queryParam.startBrowseTime = this.newBrowseDate[0]
        this.queryParam.endBrowseTime = this.newBrowseDate[1]
      }
      if (this.tagId) {
        this.queryParam.tagId = this.tagId.join('|')
      }
      this.queryParam.pageNum = 1
      this.getList()
      this.queryUserCount()
    },
    buttonReset() {
      this.buttonType1 = ''
      this.buttonType2 = ''
      this.buttonType3 = ''
      this.buttonType4 = ''
      this.buttonType5 = ''
      this.buttonType6 = ''
      this.buttonType7 = ''
      this.buttonType8 = ''
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.rangeDate = null
      this.newApplyDate = null
      this.newFollowDate = null
      this.newBrowseDate = null
      this.tagId = []
      this.queryParam = {
        newFollowName: undefined,
        tagId: undefined,
        newResultType: undefined,
        newApplyPost: undefined,
        addWx: undefined,
        sheng: undefined,
        shi: undefined,
        xian: undefined,
        ageMin: undefined,
        ageMax: undefined,
        type: 1,
        nickname: undefined,
        mobile: undefined,
        idCard: undefined,
        education: undefined,
        sourceChannel: undefined,
        sex: undefined,
        sourceType: undefined,
        topNickname: undefined,
        referralsNickname: undefined,
        topReferralsNickname: undefined,
        inviteUserName: undefined,
        startTime: undefined,
        endTime: undefined,
        startApplyTime: undefined,
        endApplyTime: undefined,
        startFollowTime: undefined,
        endFollowTime: undefined,
        startBrowseTime: undefined,
        endBrowseTime: undefined,
        location: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    operateOk() {
      const that = this
      if (that.operateType === 1) {
        const param = { userId: that.userId, remark: that.remark }
        addHighSeas(param).then(() => {
          that.getList()
          that.$message.success(
            '投入公海成功',
            3
          )
          this.operateClose()
        })
      }
      if (that.operateType === 2) {
        const param = {
          userId: that.userId,
          postId: that.postId,
          companyId: that.companyId,
          type: that.interviewType,
          entryTime: that.entryTime,
          entryWorkId: that.entryWork,
          dimissionTime: that.dimissionTime,
          content: that.remark
        }
        workbenchDispose(param).then(() => {
          that.getList()
          that.$message.success(
            '操作成功',
            3
          )
          this.operateClose()
        })
      }
      if (that.operateType === 3) {
        const param = {
          userId: that.userId,
          remark: that.remark
        }
        highSeasReceive(param).then(response => {
          that.getList()
          if (response.data === 20001) {
            that.$message.success(
              '领取成功',
              3
            )
          }
          this.operateClose()
        })
      }
    },
    operateClose() {
      this.operateOpen = false
      this.remark = null
      this.operateTitle = null
      this.operateType = null
      this.interviewType = null
      this.postId = null
      this.entryTime = null
      this.entryWork = null
      this.dimissionTime = null
      this.reportPostList = []
      this.workTypeList = []
    },
    immediateInterview(userId) {
      const param = { userId: userId }
      immediateInterview(param).then(() => {
        this.getList()
        this.$message.success(
          '操作成功',
          3
        )
      })
    },
    handleHighSeas(id) {
      this.userId = id
      this.operateTitle = '确认投入公海吗？'
      this.operateOpen = true
      this.operateType = 1
    },
    handleHighSeasReceive(id) {
      this.userId = id
      this.operateTitle = '是否领取？'
      this.operateOpen = true
      this.operateType = 3
    },
    handleInterview(id, type) {
      this.userId = id
      let title = ''
      if (type === 1) {
        title = '面试成功'
        this.interviewType = 2
        this.queryReportPostList(2)
      } else if (type === 2) {
        title = '面试失败'
        this.interviewType = 3
        this.queryReportPostList(2)
      } else if (type === 3) {
        title = '面试未到'
        this.interviewType = 1
        this.queryReportPostList(2)
      } else if (type === 4) {
        title = '为在职员工'
        this.interviewType = 4
        this.queryWorkList()
        this.queryReportPostList(5)
      } else if (type === 5) {
        title = '为面试成功体检失败'
        this.interviewType = 5
        this.queryReportPostList(5)
      } else if (type === 6) {
        title = '为面试成功体检失败需复检'
        this.interviewType = 6
        this.queryReportPostList(5)
      } else if (type === 7) {
        title = '为面试成功未体检'
        this.interviewType = 7
        this.queryReportPostList(5)
      } else if (type === 8) {
        title = '为体检成功未入职'
        this.interviewType = 8
        this.queryReportPostList(5)
      } else if (type === 9) {
        title = '为复检成功并入职'
        this.interviewType = 9
        this.queryWorkList()
        this.queryReportPostList(7)
      } else if (type === 10) {
        title = '为复检成功未入职'
        this.interviewType = 10
        this.queryReportPostList(7)
      } else if (type === 11) {
        title = '为复检失败'
        this.interviewType = 11
        this.queryReportPostList(7)
      } else if (type === 12) {
        title = '为离职员工'
        this.interviewType = 12
        this.queryReportPostList(10)
      }
      this.operateTitle = '确认' + title + '吗？'
      this.operateOpen = true
      this.operateType = 2
    },
    queryReportPostList(status) {
      const param = { userId: this.userId, status: status }
      listReportPost(param).then(res => {
        this.reportPostList = res.data
        if (this.reportPostList) {
          this.postId = this.reportPostList[0].postId
          this.companyId = this.reportPostList[0].companyId
        }
      })
    },
    queryWorkList() {
      const param = {}
      listWork(param).then(response => {
        this.workTypeList = response.data
      })
    },
    handleStatus(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$refs.setStatusForm.handleAdd(ids)
      that.onSelectChange([], [])
      that.getList()
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('biz/user/export', {
            ...that.queryParam
          }, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
